export const isAboutSectionSearch = (section: string) => section === 'about';
export const getSearchPathBy = (section: string) => {
  switch (section) {
    case 'about':
      return 'about/search';
    default:
      return 'article-search';
  }
};
